module.exports = __webpack_public_path__ + "img/ic_medal.9ff421c2.svg";